var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeaderInvoice = function SvgHeaderInvoice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15300",
    "data-name": "Group 15300",
    transform: "translate(-1750 -648)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 24,
    height: 24,
    transform: "translate(1750 648)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "clipboard-text",
    transform: "translate(1754.8 652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M2.4,2.4h2a2.4,2.4,0,1,1,4.8,0h2a2.4,2.4,0,0,1,2.4,2.4v8.8A2.4,2.4,0,0,1,11.2,16H2.4A2.4,2.4,0,0,1,0,13.6V4.8A2.4,2.4,0,0,1,2.4,2.4Zm0,.8A1.6,1.6,0,0,0,.8,4.8v8.8a1.6,1.6,0,0,0,1.6,1.6h8.8a1.6,1.6,0,0,0,1.6-1.6V4.8a1.6,1.6,0,0,0-1.6-1.6h-.8V5.6H3.2V3.2ZM4,4.8H9.6V3.2H4ZM6.8.8A1.6,1.6,0,0,0,5.2,2.4H8.4A1.6,1.6,0,0,0,6.8.8ZM2.4,7.2h8.8V8H2.4Zm0,2.4h8.8v.8H2.4Zm0,2.4H9.6v.8H2.4Z",
    transform: "translate(0 0)",
    fill: "#108060"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeaderInvoice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/header-invoice.51653434.svg";
export { ForwardRef as ReactComponent };